import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Assignment } from 'src/app/classes/assignment';
import { Shift } from 'src/app/classes/shift';
import { SettingsService } from 'src/app/services/settings.service';
import { ShiftService } from 'src/app/services/shift.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { FeedbackComponent } from './feedback/feedback.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NotesComponent } from './notes/notes.component';
import { ChangeComponent } from './change/change.component';
import TaskStatuses from 'src/app/constants/task-statuses';
import { ProductAddComponent } from './product-add/product-add.component';
import { ShiftProduct } from 'src/app/classes/shift-product';
import { Organization } from 'src/app/classes/organization';
import { CancelComponent } from './cancel/cancel.component';
import { DetailsComponent } from './details/details.component';
import { Share } from '@capacitor/share';
import { CustomerService } from 'src/app/services/customer.service';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { TranslateFieldPipe } from 'src/app/pipes/translate-field.pipe';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { Platform } from '@ionic/angular';
import { Title } from '@angular/platform-browser';
import { MessagesComponent } from './messages/messages.component';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  providers: [TranslateFieldPipe, DatePipe]
})
export class EditComponent implements OnInit, OnDestroy {
  show = false
  shift = new Shift()
  askFeedback = false
  currentUser = new CustomerContact()
  onGoing = $localize`Ongoing`

  canShare = false

  assignments: Assignment[] = []
  taskStatuses = TaskStatuses
  organization = new Organization()

  fa = fa

  listenSub!: Subscription
  resumeSub!: Subscription
  
  editForm = new FormGroup({
    start_time: new FormControl(),
    end_time: new FormControl(),
    lunch_start: new FormControl(),
    lunch_end: new FormControl(),
    assignment_id: new FormControl()
  })

  constructor(
    private shiftService: ShiftService,
    private settingsService: SettingsService,
    private customerService: CustomerService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private router: Router,
    private translateFieldPipe: TranslateFieldPipe,
    private datePipe: DatePipe,
    private platform: Platform,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.shiftService.initSocket()

    Share.canShare().then((res) => {
      this.canShare = res.value  
    })

    this.customerService.current().subscribe(contact => {
      this.currentUser = contact
    })

    this.settingsService.organization().subscribe(organization => {
      this.organization = organization
    })

    this.listenSub = this.shiftService.listen().subscribe(update => {
      if(update.shift_id == this.shift.id) {
        this.get()
      }
    })

    this.settingsService.assignments().subscribe(assignments => {
      this.assignments = assignments

      this.get()

      this.route.queryParams.subscribe(qParams => {
        if(qParams['ask_feedback'] == 'true')
          this.feedback(this.shift)
      })
    })

    this.resumeSub = this.platform.resume.subscribe(async () => {
      this.get()
    })
  }

  ngOnDestroy() {
    if(this.listenSub) {
      this.listenSub.unsubscribe()
    }


    if(this.resumeSub) {
      this.resumeSub.unsubscribe()
    }
  }

  feedback(shift: Shift) {
    const modalRef = this.modalService.open(FeedbackComponent, { centered: true });

    modalRef.componentInstance.shift = shift

    modalRef.result.then(() => {
      this.get()
    })
  }

  get() {
    this.shiftService.shift(this.shift.id).subscribe(data => {
      this.titleService.setTitle(this.translateFieldPipe.transform(data.assignment, 'name') + ' - ' + this.datePipe.transform(data.start, 'short'))
      this.shift = { ...data };

      data.start_time = data.start.split('T')[1]
      data.end_time = data.end.split('T')[1]

      if (data.lunch_start && data.lunch_end) {
        data.lunch_start = data.lunch_start.split('T')[1]
        data.lunch_end = data.lunch_end.split('T')[1]
      }

      this.editForm.patchValue(data);

      this.show = true
    }, (error) => {
      this.activeModal.close()
    })
  }

  notes() {
    const modalRef = this.modalService.open(NotesComponent, { centered: true })

    modalRef.componentInstance.shift = this.shift

    modalRef.result.then(() => {
      this.get()
    })
  }

  productAdd(shiftId: number) {
    const modalRef = this.modalService.open(ProductAddComponent, { centered: true, size: 'lg' });

    modalRef.componentInstance.shift = this.shift

    modalRef.result.then(() => {
      this.get()
    })
  }

  productEdit(shiftId: number, product: ShiftProduct) {
    /*
    const modalRef = this.modalService.open(ProductEditComponent, { centered: true });

    modalRef.componentInstance.shiftId = shiftId
    modalRef.componentInstance.product = product

    modalRef.result.then(() => {
      this.get()
    })
    */
  }

  details() {
    const modal = this.modalService.open(DetailsComponent, { centered: true, size: 'lg' })

    modal.componentInstance.shift = this.shift
  }

  cancel() {
    const modal = this.modalService.open(CancelComponent, { centered: true });
    
    modal.componentInstance.shift = this.shift

    modal.result.then((result) => {
      if(result == 'close') {
        this.activeModal.close()
      }
    })
  }

  messages(shift: Shift) {
    const modalRef = this.modalService.open(MessagesComponent, { centered: true, size: 'xl', fullscreen: 'lg', scrollable: false })

    modalRef.componentInstance.shift = shift
  }

  copy() {
    const order: any = {
      assignment_id: this.shift.assignment_id,
      employee_id: this.shift.employee_id,
      customer: {
        id: this.shift.customer.id,
        street_address: this.shift.customer.street_address,
        office: this.shift.customer.office,
        city: this.shift.customer.city,
        area_id: this.shift.customer.area_id
      },
      products: this.shift.products.reduce((acc: Record<number, number>, curr) => {
        acc[Number(curr.product_id)] = Number(curr.number)
        return acc; 
      }, {} as Record<number, number>)
    }

    if(new Date(this.shift.start) > new Date()) {
      order.start_date = this.shift.start.split('T')[0]
    }

    localStorage.setItem('order', JSON.stringify(order))

    this.router.navigate(['/'])
    this.activeModal.close()
  }

  requestChange() {
    const modalRef = this.modalService.open(ChangeComponent, { centered: true });

    modalRef.componentInstance.shift = this.shift

    modalRef.result.then(() => {
      this.get()
    })
  }

  save() {
    this.shiftService.save(this.shift.id, this.editForm.value).subscribe(_data => {
      this.activeModal.close()
    })
  }

  async share() {
    console.log(this.shift.assignment)
    const assignmentName = this.translateFieldPipe.transform(this.shift.assignment, 'name')
    const start = this.datePipe.transform(this.shift.start, 'short')
    const end = this.datePipe.transform(this.shift.end, 'shortTime')

    
    await Share.share({
      title: $localize`Order information`,
      text: `${assignmentName}, ${this.shift.employee.first_name}\n${start}-${end}\n${this.shift.customer.street_address}${this.shift.customer.office ? ', '+this.shift.customer.office : ''} ${this.shift.customer.city}`,
    });
  }

  public msToHumanDuration(ms: number): string {
    const minutes = Math.floor(ms / 1000 / 60);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours === 0) {
      return minutes === 1 
        ? $localize`1 minute`
        : $localize`${minutes} minutes`;
    }

    const hourLabel = hours === 1
      ? $localize`1 hour`
      : $localize`${hours} hours`;
      
    if (remainingMinutes === 0) {
      return hourLabel;
    }

    const minuteLabel = remainingMinutes === 1
      ? $localize`1 minute`
      : $localize`${remainingMinutes} minutes`;

    return `${hourLabel} ${minuteLabel}`;
  }
}
